import cookie from 'vue-cookies'
import router from '../../router'
import { PowerService } from '../../service/power.service'
const routes = {
    state: {
        newrouter: cookie.get('newrouter'),//权限路由
        viewrouter: cookie.get('viewrouter')//可视路由
    },
    mutations: {
        SET_NEWROUTER(state,newrouter){
            state.newrouter = newrouter
        }
    },
    actions: {
         GetMenu: ({commit}) => {
            return new Promise( async () => {
                const data = await PowerService.getPowerList()
                    let menu = {}
                    menu = data.map((val) => {
                        return {
                            path: val.route_url,
                            component: () => import('@/views' + val.route_url + '.vue'),
                            meta: {title:val.name,type: val.type === "2" ? true : false},//如果type为2则在侧边栏显示路由
                            children: val.sub ? val.sub.map((v) => {
                                return {
                                    path: v.route_url,
                                    meta: {title:v.name,type: v.type === "2" ? true : false},
                                    component: () => import('@/views' + v.route_url + '.vue'),
                                    children: v.sub ? v.sub.map((m) => {
                                        return {
                                            path: m.route_url,
                                            meta: {title:m.name,type: v.type == "2" ? true : false},
                                            component: () => import('@/views' + m.route_url + '.vue'),
                                            children: m.sub ? m.sub.map((n) => {
                                                return {
                                                    path: n.route_url,
                                                    meta: {title:n.name,type: v.type == "2" ? true : false},
                                                    component: () => import('@/views' + n.route_url + '.vue'),
                                                }
                                            }): ""
                                        }
                                    }) : ""
                                }
                            }): ""
                        } 
                    })
                    router.addRoutes(menu)
                    commit('SET_NEWROUTER',menu)
                    //router.addRoutes([{path: "/personal/index",name: "personal",component: () => import ('@/views/personal/index')}])
                }) 
            
        
        }
       
    }
}

export default routes